import state from './lmsState'
import mutations from './lmsMutations'
import getters from './lmsGetters'
import actions from './lmsActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
